export const LABEL_MIXIN_BY_BUTTON_SIZE_MAP = {
    "28": "caption-m-accent",
    "36": "title-s",
    "44": "title-m",
    "56": "title-m",
} as const;
